module.exports = __webpack_public_path__ + "img/chenghong.71b7ed12.png";